import { HStack, Text, Center, FlatList, Box, Spinner } from "native-base";
import colors from "theme/colors";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const HeaderCell = ({ children = null, rightDivider = false, containerStyle, containerProps }) => {
  return (
    <Box bg={colors.neutral.mist} py="10px" style={containerStyle} {...containerProps}>
      <Center style={styles.headerCenter}>
        <Text color={colors.neutral.charcoal} variant="xs-bold">
          {children}
        </Text>
      </Center>
      {rightDivider ? <Text style={{ borderRightWidth: 1, borderColor: colors.disabled.smoke }} /> : null}
    </Box>
  );
};

const Cell = ({ children = null, containerStyle, containerProps }) => {
  return (
    <Box
      bg={colors.neutral.cotton}
      py="10px"
      px="24px"
      style={[{ borderBottomWidth: 1, borderBottomColor: colors.neutral.mist }, containerStyle]}
      {...containerProps}
    >
      <Center style={styles.cell}>
        <Text color={colors.neutral.charcoal} variant="xs">
          {children}
        </Text>
      </Center>
    </Box>
  );
};

const Header = () => {
  const { t } = useTranslation("common");

  return (
    <HStack backgroundColor={colors.neutral.mist}>
      <HeaderCell rightDivider containerStyle={styles.headerNo}>
        {t("groupPaydate.columnOne")}
      </HeaderCell>
      <HeaderCell rightDivider containerStyle={styles.headerCommon}>
        {t("groupPaydate.columnTwo")}
      </HeaderCell>
      <HeaderCell containerStyle={styles.headerCommon}>{t("groupPaydate.columnThree")}</HeaderCell>
    </HStack>
  );
};

const Row = (item) => {
  const row = item.row.item;
  const idx = item.row.index;

  const { t } = useTranslation("common");
  return (
    <HStack zIndex={2}>
      <Cell containerStyle={styles.cellNo}>{idx + 1}</Cell>
      <Cell containerStyle={styles.cellCommon}>{row?.groupName}</Cell>
      <Cell containerStyle={styles.cellCommon}>
        {row?.payDates
          ?.map((e) => {
            if (e === "-1") return t("home.list.rows.endMonth");
            return e;
          })
          .join(", ")}
      </Cell>
    </HStack>
  );
};

function shouldRenderLoanOrLoader(loading, data, currentPage) {
  if (loading) return <Spinner size="sm" />;
  return (
    <FlatList
      data={data}
      ListHeaderComponent={Header}
      showsHorizontalScrollIndicator={false}
      renderItem={(item, idx) => <Row row={item} rowIdx={idx} currentPage={currentPage} />}
      style={styles.flatlistStyle}
    />
  );
}

const GroupPayTable = ({ data = {}, loading = false, currentPage = 1 }) => {
  return <>{shouldRenderLoanOrLoader(loading, data, currentPage)}</>;
};

export default GroupPayTable;
